import {
  ContextMenu,
  ContextMenuPopup,
  ContextMenuPortal,
  ContextMenuPositioner,
} from '@/components/ui/context-menu'

import { preventDefaults } from '@/utils/events'

import { CellContextMenu } from '../cell/CellContextMenu'
import { ColumnContextMenu } from '../column/ColumnContextMenu'

import type { ContextMenuType } from './grid.store'
import { gridStateActions, useGridSnap } from './grid.store'

/**
 * Host component to contextmenus used inside the grid scope.
 *
 * Takes a ref, so that the contextmenu can be included when doing
 * focus-detection for hotkey handlers.
 */
export function GridContextMenu({ ref }: { ref: React.Ref<HTMLDivElement> }) {
  const { contextMenu } = useGridSnap()

  if (!contextMenu) return null

  const virtualAnchor = {
    getBoundingClientRect: () => ({
      width: 0,
      height: 0,
      top: contextMenu?.y ?? 0,
      left: contextMenu?.x ?? 0,
      right: contextMenu?.x ?? 0,
      bottom: contextMenu?.y ?? 0,
      x: contextMenu?.x ?? 0,
      y: contextMenu?.y ?? 0,
      toJSON: () => {},
    }),
  }

  return (
    <ContextMenu
      open={Boolean(contextMenu)}
      onOpenChange={(open) => {
        if (!open) gridStateActions.contextMenu.close()
      }}
    >
      <ContextMenuPortal onContextMenu={preventDefaults}>
        <ContextMenuPositioner
          anchor={virtualAnchor}
          positionMethod="fixed"
        >
          <ContextMenuPopup ref={ref}>
            {getContextMenuContentForType(contextMenu.type)}
          </ContextMenuPopup>
        </ContextMenuPositioner>
      </ContextMenuPortal>
    </ContextMenu>
  )
}

function getContextMenuContentForType(type: ContextMenuType) {
  switch (type) {
    case 'cell':
      return <CellContextMenu />

    case 'column':
      return <ColumnContextMenu />

    case 'cue':
      return <></>

    default: {
      const _exhaustive: never = type
      return _exhaustive
    }
  }
}
